import { mobileApiRequest } from '../utils/request/applicationRequests';

export const apiZipcodeSarch = async (query: string): Promise<string[]> => {
  const res = await mobileApiRequest.post('/zipcode-search', {
    zipcode: query,
  });

  return res.states;
};

export const apiCoverageTypes = async (zipcode: string, state: string): Promise<boolean> => {
  const res = await mobileApiRequest.post('/smb/coverage-types', {
    census: { zipcode, state },
  });

  // find whether thimble supports this state
  return (
    (
      res.results as {
        type: string;
        is_available: string;
      }[]
    ).findIndex(({ type, is_available }) => type === 'gl' && is_available) !== -1
  );
};
